export default __webpack_public_path__ + "static/media/reanime-in-app.1abb00f8.png";